import { RootState } from 'redux/reducers/rootReducer';
import { LayoutModeEnum } from 'enums/LayoutModeEnum';

export const isLightThemeSelector = (state: RootState) =>
  state.theme.layoutMode === LayoutModeEnum.Light;
